import React from "react";
import "./partnershipsectopn2.css";

export default function PartnershipSection2() {
  return (
    <div className="same_width_container bg_partnership_section2_bg">
      <div className="title_content_box_container">
        <h6>Partnerships & Accreditation: Our Guarantee of Quality Service</h6>
        <p>
          We have a team of highly qualified technicians, each certified with
          WETT certifications for Levels 1, 2, and 3 inspections. Our
          technicians hold an extensive experience within the industry,
          guaranteeing a deep understanding of fireplace systems and the ability
          to deliver exceptional service.
        </p>
        <div className="box_partnership_section"></div>
      </div>
    </div>
  );
}
